
    import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
    import Vue from "vue";
    import Component from "vue-class-component";
    import {
        Certificate,
        CertificatesClient,
        CertificateStatus, DuplicableDocumentModelDocumentType, SeafarerActions

    } from "@/api-client";
    import {BModal} from "bootstrap-vue";
    import {Prop} from "vue-property-decorator";
    import userInfo from "@/features/shared/components/UserInfo";
    import ClientsidePaging from "@/components/ClientsidePaging";
    import FilterCheckbox from "@/components/FilterCheckbox.vue";
    import {factory} from "@/api-client.extensions";
    import NewCertificateCard from "@/features/applications/components/new-application/NewCertificateCard.vue";
    import NewDuplicateCard from "@/features/applications/components/new-application/NewDuplicateCard.vue";
    import NewConcessionPermitCard from "@/features/applications/components/new-application/NewConcessionPermitCard.vue";
    import {NavigationGuardNext} from "vue-router/types/router";
    import CertificatesTable from "@/features/personProfile/components/CertificatesTable.vue";

    interface Props {
        certificates: Certificate[];
        seafarerId: string;
        seafarerActions?: SeafarerActions;
    }

    @Component({
        components: {
            CertificatesTable,
            SectionPageHeading,
            FilterCheckbox,
            NewCertificateCard,
            NewDuplicateCard,
            NewConcessionPermitCard
        },
        beforeRouteEnter(to, from, next: NavigationGuardNext<CertificateList>) {
            const props = to.meta!.props as Props;
            props.seafarerId = to.params.seafarerId;
            Promise.all([
                new CertificatesClient().certificates(to.params.seafarerId)
            ]).then(values => {
                props.certificates = values[0].certificates;
                next();
            }).catch(e => next(e))
        }
    })
    export default class CertificateList extends Vue implements Props {
        @Prop({required: true})
        certificates!:Certificate[];
        @Prop({required: true})
        seafarerId!: string;
        @Prop({required: false, default: () => factory.create(SeafarerActions) })
        seafarerActions!: SeafarerActions;

        userInfo = userInfo;

        showValid = true;
        showInvalid = false;
        // showSuspended = true;

        $refs!: {
            newApplicationModal: BModal;
        }

        duplicateDocumentType = DuplicableDocumentModelDocumentType;

        openNewApplicationModal() {
            this.$refs.newApplicationModal.show();
        }

        get filteredCertificates(): Certificate[] {
            let filteredCertificates = this.certificates;

            // Remove certificates in 'valid' status if necessary
            if (!this.showValid)
                filteredCertificates = filteredCertificates.filter(c => c.status !== CertificateStatus.Valid);

            // Remove certificates in 'invalid' status if necessary
            if (!this.showInvalid)
                filteredCertificates = filteredCertificates.filter(c => c.status !== CertificateStatus.Invalid);

            // // Remove certificates in 'suspended' status if necessary
            // if (!this.showSuspended)
            //     filteredCertificates = filteredCertificates.filter(c => c.status !== CertificateStatus.Suspended);

            return filteredCertificates;
        }
    }
